//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            //登录信息暂存
            doctorname: this.$route.query.doctorname || '',
            telephone: this.$route.query.telephone || '',
            phoneCode: this.$route.query.phoneCode || '',
            site: this.$route.query.site || '',
            siteId: this.$route.query.siteId || '',
            hospitaid: this.$route.query.hospitaid || '',
            hospitaname: this.$route.query.hospitaname || '',
            parameters: '',
            hospitainfoName: []
        }
    },
    //挂载完成
    methods: {
        getListByKey(){
            let params = {
                parameters: this.parameters
            };
            this.$doRequest("/api/AppHomePage/getHospitainfoName", params,res => {
                this.hospitainfoName = res.mapre;
            });
        },
        selectName(id,name){
            this.$router.push({path: '/login', query: {
                        doctorname: this.doctorname,
                        telephone: this.telephone,
                        phoneCode: this.phoneCode,
                        site: this.site,
                        siteId: this.siteId,
                        hospitainfoName: name,
                        hospitaid: id}
                    });
        },
        search(){
            this.getListByKey();
        }
    },
    //生命周期之创建完成
    created: function() {
        this.getListByKey();
        document.title = '医疗机构';
    }
}



// WEBPACK FOOTER //
// ./src/views/hospitalList/index.vue